import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-membership-search',
  templateUrl: './membership-search.component.html',
  styleUrls: ['./membership-search.component.css']
})
export class MembershipSearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
